import styled from 'styled-components';
import typography from '../../theme/typography';

export const PageTitle = styled.h1`
  margin-bottom: 30px;
  margin-top: 30px;
`;

export const Subheading = styled.h3`
  font-weight: ${typography.fontWeights.robotoRegular};
  margin-bottom: 20px;
`;
